module.exports = __webpack_public_path__ + "static/mybase-heroimg-ab232986a905684ff519a16cab181e4e.png";